import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { errorMessages } from '~/constants/errorMessages.ts';
import api from '~/libs/api';
import { TDictionaryDocuments } from './types';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';

const getDocType = () => async () => {
  try {
    const { data } = await api.get(`/dictionary-service/doctype`);
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const useDocumentsQuery = () => {
  const { data, error, isLoading, isError } = useQuery<TDictionaryDocuments>({
    queryKey: ['doctype'],
    queryFn: getDocType(),
    staleTime: 30 * 60 * 1000,
  });

  const personalDocOptions: TAutocompleteOption[] = useMemo(() => {
    if (!data?.docTypesPE) return [];
    return data?.docTypesPE.map((document) => ({
      value: document.id.toString(),
      label: document.name,
    }));
  }, [data]);

  return {
    personalDocOptions,
    personalDocs: data?.docTypesPE,
    webDocs: data?.docTypesWeb,
    error,
    isLoading,
    isError,
  };
};
